import React, { useState } from "react";
import GlobalStyles from 'styles/GlobalStyles';
import { css } from "styled-components/macro"; //eslint-disable-line

import MainLandingPage from "MainLandingPage.js";
import ScrollToTop from "components/scrolltotop.js";
import LanguageSwitcher from "components/languageSwitcher";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './i18n'; // ✅ Importar i18n correctamente
import { useTranslation } from "react-i18next";

export default function App() {
  const { i18n } = useTranslation();
  const [activeLanguage, setActiveLanguage] = useState('es');

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setActiveLanguage(lng);
  };

  return (
    <>
      <GlobalStyles />
      <Router>
        <LanguageSwitcher changeLanguage={changeLanguage} activeLanguage={activeLanguage} />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<MainLandingPage />} />
        </Routes>
      </Router>
    </>
  );
}